import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { PostAlert } from "./AlertActions";
import { Logout } from "./LoginActions";
import { RequestNav } from "./NavActions";
export function QuickSearch(searchText, qsCallback, nav) {
  console.log("quicksearch");
  if (!searchText.includes("AND") && !searchText.includes("OR") && !searchText.includes('"')) {
    let st2 = searchText.split(" ");
    while (st2.indexOf("") !== -1) {
      st2.splice(st2.indexOf(""), 1);
    }
    for (var i = 0; i < st2.length; i++) {
      if (st2[i].indexOf(",") !== -1) st2[i] = `"${st2[i]}"`;
    }
    if (st2.length > 1) {
      searchText = "";
      st2.forEach((part) => {
        if (searchText !== "") searchText += " OR ";
        searchText += part;
      });
    } else {
      searchText = st2[0];
    }
  }
  console.log(searchText);
  axios.post(
    `${Globals.baseUrl}/Search/QuickSearch`,
    {
      search: searchText
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    console.log(res.data);
    console.log(qsCallback);
    if (res.status === 200) {
      if (res.data.documentCount === 0) {
        qsCallback(false);
        PostAlert("error", "No matching documents found");
      } else {
        qsCallback(true);
      }
      res.data.searchText = searchText;
      dispatcher.dispatch({
        actionType: actionTypes.SearchQuickSearch,
        Result: res.data
      });
      console.log(res.data);
      if (res.data.documentCount === 1) {
        console.log("1 document");
        let docId = res.data.documentIds[0];
        nav(`Document ${docId}`, `/Document/${docId}`);
      } else if (res.data.documentCount > 1) {
        let tree = res.data.searchResult.adTree;
        let branch1 = tree[0];
        if (branch1.type === "ou") {
          branch1 = branch1.children[0];
        }
        let bp = branch1.id;
        nav("Search", `/Search?BP=${bp}&Value=${res.data.searchText}`);
      }
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
  });
}
export function SearchByDocumentId(searchText) {
  axios.post(
    `${Globals.baseUrl}/Search/SearchByDocumentId`,
    {
      search: searchText
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      if (res.data.documentCount === 0) {
        PostAlert("error", "No matching documents found");
      }
      dispatcher.dispatch({
        actionType: actionTypes.SearchByDocId,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
  });
}
export function SearchByValues(searchText, documentsToSearch) {
  console.log("SearchByValues");
  if (!searchText.includes("AND") && !searchText.includes("OR") && !searchText.includes('"')) {
    let st2 = searchText.split(" ");
    while (st2.indexOf("") !== -1) {
      st2.splice(st2.indexOf(""), 1);
    }
    for (var i = 0; i < st2.length; i++) {
      if (st2[i].indexOf(",") !== -1) st2[i] = `"${st2[i]}"`;
    }
    if (st2.length > 1) {
      searchText = "";
      st2.forEach((part) => {
        if (searchText !== "") searchText += " OR ";
        searchText += part;
      });
    } else {
      searchText = st2[0];
    }
  }
  console.log(searchText);
  axios.post(
    `${Globals.baseUrl}/Search/SearchByValues`,
    {
      search: searchText,
      documentsToSearch
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.data.documentCount === 0) {
      PostAlert("error", "No matching documents found");
    }
    if (res.status === 200) {
      res.data.searchText = searchText;
      dispatcher.dispatch({
        actionType: actionTypes.SearchByValues,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
  });
}
export function GetSearchStep(id, bpId, value, searchType, data, userAudit, userName, column, order, offset, documentsToSearch) {
  console.log("GetSearchStep");
  axios.post(
    `${Globals.baseUrl}/Search/GetSearchStep`,
    {
      id,
      bpId,
      value,
      searchType,
      data,
      userAudit,
      userName,
      column: column.toString(),
      order: order.toString(),
      offset: offset.toString(),
      documentsToSearch
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      res.request = {
        id,
        bpId,
        value,
        searchType,
        data,
        userAudit,
        userName,
        column: column.toString(),
        order: order.toString(),
        offset: offset.toString()
      };
      dispatcher.dispatch({
        actionType: actionTypes.SearchGetStep,
        Result: result
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetSearchBp(bpId, value, searchType, data, userAudit, userName, column, order, offset, documentsToSearch) {
  console.log("SearchBp");
  axios.post(
    `${Globals.baseUrl}/Search/GetSearchBp`,
    {
      id: "0",
      bpId,
      value,
      searchType,
      data,
      userAudit,
      userName,
      column: column.toString(),
      order: order.toString(),
      offset: offset.toString(),
      documentsToSearch
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.SearchGetBp,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetIndexFields() {
  axios.get(`${Globals.baseUrl}/Search/GetIndexFields`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.GetIndexFields,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    let result = {
      updateStatus: "Error",
      errorMessage: "401: Bad request"
    };
    dispatcher.dispatch({
      actionType: actionTypes.GetIndexFields,
      Result: result
    });
  });
}
export function SearchByFieldValue(data, documentsToSearch) {
  axios.post(
    `${Globals.baseUrl}/Search/SearchByFieldValue`,
    {
      data,
      documentsToSearch
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      if (res.data.documentCount === 0) {
        PostAlert("error", "No matching documents found");
      }
      dispatcher.dispatch({
        actionType: actionTypes.SearchByFieldValue,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
  });
}
export function GetWorkflowUserSteps() {
  axios.get(`${Globals.baseUrl}/Search/GetWorkflowUserSteps`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.WorkflowGetUserSteps,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
    }
  }).catch((res) => {
    console.log(res);
  });
}
export function SearchByUserAudit(data, documentsToSearch) {
  axios.post(
    `${Globals.baseUrl}/Search/SearchByUserAudit`,
    {
      userId: data.userId,
      stepId: data.stepId,
      startDate: data.startDate,
      endDate: data.endDate,
      action: data.action,
      documentsToSearch
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.data.documentCount === 0) {
      PostAlert("error", "No matching documents found");
    }
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.SearchByUserAudit,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
  });
}
export function SearchByUserQueue(searchText, documentsToSearch) {
  axios.post(
    `${Globals.baseUrl}/Search/SearchByUserQueue`,
    {
      userName: searchText,
      documentsToSearch
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.data.documentCount === 0) {
      PostAlert("error", "No matching documents found");
    }
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.SearchByUserQueue,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
  });
}
export function SearchByNotes(searchText, documentsToSearch) {
  console.log("search Notes");
  axios.post(
    `${Globals.baseUrl}/Search/SearchByNotes`,
    {
      search: searchText,
      documentsToSearch
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.data.documentCount === 0) {
      PostAlert("error", "No matching documents found");
    }
    if (res.status === 200) {
      console.log(res.data);
      dispatcher.dispatch({
        actionType: actionTypes.SearchByNotes,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
  });
}
export function SearchByProperties(searchText, documentsToSearch) {
  console.log("Search by properties");
  axios.post(
    `${Globals.baseUrl}/Search/SearchByProperties`,
    {
      search: searchText,
      documentsToSearch
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.data.documentCount === 0) {
      PostAlert("error", "No matching documents found");
    }
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.SearchByProperties,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
  });
}
